const sizes = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const kbdPropDefs = {
    size: { type: 'enum', values: sizes, default: undefined, responsive: true },
};
export { kbdPropDefs };
//# sourceMappingURL=kbd.props.js.map